import { createSlice, createAction, PayloadAction } from '@reduxjs/toolkit'
import { BlogPost } from '../types'
import { ApiError, RequestStatus } from 'features/common'

export const name = 'Home'

export interface HomeState {
  blogPosts: BlogPost[]
  blogPostsStatus: RequestStatus
  blogPostsError?: ApiError
}

const initialState: HomeState = {
  blogPosts: [],
  blogPostsStatus: RequestStatus.Idle
}

const asyncActions = {
  fetchBlogPostsRequest: createAction(`${name}/get_blog_posts`)
}

const reducers = {
  setBlogPosts: (state: HomeState, action: PayloadAction<Array<BlogPost>>) => {
    state.blogPosts = action.payload
  },
  setBlogPostsStatus: (state: HomeState, action: PayloadAction<RequestStatus>) => {
    state.blogPostsStatus = action.payload
  },
  setBlogPostsError: (state: HomeState, action: PayloadAction<ApiError>) => {
    state.blogPostsError = action.payload
  }
}

export const HomeSlice = createSlice({
  name,
  initialState,
  reducers
})

export const { setBlogPosts, setBlogPostsStatus, setBlogPostsError } = HomeSlice.actions

export const { fetchBlogPostsRequest } = asyncActions

export default HomeSlice.reducer
